import { createContext } from 'react';

export interface EditorData {
  docid: string;
  isprivate?: string;
  projectid: string;
  sectionid: string;
}

export const EditorDataContext =
  createContext<EditorData | undefined>(undefined);
